module.exports = __webpack_public_path__ + "img/laugh&cry.8eddd088.gif";